/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TemperatureHandling = {
    KeepFrozen: 'KeepFrozen',
    KeepRefrigerated: 'KeepRefrigerated',
    ProtectFromFreezing: 'ProtectFromFreezing',
    NoSpecialHandling: 'NoSpecialHandling'
} as const;
export type TemperatureHandling = typeof TemperatureHandling[keyof typeof TemperatureHandling];


export function instanceOfTemperatureHandling(value: any): boolean {
    for (const key in TemperatureHandling) {
        if (Object.prototype.hasOwnProperty.call(TemperatureHandling, key)) {
            if (TemperatureHandling[key as keyof typeof TemperatureHandling] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TemperatureHandlingFromJSON(json: any): TemperatureHandling {
    return TemperatureHandlingFromJSONTyped(json, false);
}

export function TemperatureHandlingFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemperatureHandling {
    return json as TemperatureHandling;
}

export function TemperatureHandlingToJSON(value?: TemperatureHandling | null): any {
    return value as any;
}

export function TemperatureHandlingToJSONTyped(value: any, ignoreDiscriminator: boolean): TemperatureHandling {
    return value as TemperatureHandling;
}

